
import React from 'react';
import { Button } from '@/components/ui/button';
import { Link } from 'react-router-dom';
import { Layers } from 'lucide-react';

const PortalsHeader = () => {
  return (
    <section className="pt-24 pb-12 md:pt-32 md:pb-16 bg-gradient-to-br from-blue-800/5 to-blue-900/10">
      <div className="container mx-auto px-4">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          <div className="order-2 lg:order-1">
            <h1 className="text-4xl md:text-5xl font-bold text-gray-800 mb-6">
              Moderne <span className="text-blue-700">Portallösungen</span> für Kunden und Partner
            </h1>
            <p className="text-lg text-gray-600 mb-8">
              Verbessern Sie die Interaktion mit Ihren Kunden, Partnern und Mitarbeitern durch maßgeschneiderte Portale. 
              Bieten Sie Self-Service, Informationszugang und Zusammenarbeit auf höchstem Niveau.
            </p>
            <div className="flex flex-wrap gap-4">
              <Button asChild size="lg" className="bg-blue-700 hover:bg-blue-800 text-white shadow-md hover:shadow-lg transition-all duration-300">
                <Link to="/about">Beratungstermin vereinbaren</Link>
              </Button>
              <Button asChild variant="outline" size="lg" className="border-blue-700 text-blue-700 hover:bg-blue-50">
                <Link to="/references">Erfolgsbeispiele ansehen</Link>
              </Button>
            </div>
          </div>
          <div className="order-1 lg:order-2 flex justify-center lg:justify-end">
            <div className="relative">
              <div className="absolute inset-0 bg-blue-700 rounded-full blur-3xl opacity-20 transform -translate-x-4 translate-y-4"></div>
              <div className="relative bg-white p-6 shadow-xl rounded-xl border border-gray-100 hover:shadow-blue-200/30 transition-all duration-300">
                <div className="flex justify-center mb-6">
                  <div className="p-3 bg-blue-50 rounded-full">
                    <Layers className="h-12 w-12 text-blue-700" />
                  </div>
                </div>
                <div className="grid grid-cols-2 gap-4">
                  <div className="bg-blue-50 p-3 rounded-lg text-center hover:bg-blue-100 transition-colors duration-300">
                    <h3 className="font-medium text-sm text-gray-800">Kundenportale</h3>
                    <p className="text-xs text-gray-600 mt-1">Serviceanfragen, Bestellungen, Support</p>
                  </div>
                  <div className="bg-orange-50 p-3 rounded-lg text-center hover:bg-orange-100 transition-colors duration-300">
                    <h3 className="font-medium text-sm text-gray-800">Partnerportale</h3>
                    <p className="text-xs text-gray-600 mt-1">Vertriebspartner, Lieferanten, B2B</p>
                  </div>
                  <div className="bg-blue-50 p-3 rounded-lg text-center hover:bg-blue-100 transition-colors duration-300">
                    <h3 className="font-medium text-sm text-gray-800">Mitarbeiterportale</h3>
                    <p className="text-xs text-gray-600 mt-1">Intranet, Workflows, Wissensmanagement</p>
                  </div>
                  <div className="bg-green-50 p-3 rounded-lg text-center hover:bg-green-100 transition-colors duration-300">
                    <h3 className="font-medium text-sm text-gray-800">Self-Service</h3>
                    <p className="text-xs text-gray-600 mt-1">24/7 Zugang zu Services und Informationen</p>
                  </div>
                </div>
                <div className="mt-4 text-center p-3 bg-gray-50 rounded-lg hover:bg-gray-100 transition-colors duration-300">
                  <p className="text-sm text-gray-600">Individuell angepasst an Ihre Unternehmensanforderungen</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default PortalsHeader;
